import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useEffectOnlyOnce } from 'sharedHooks';
import { apiCallStatus } from 'helpers/constants';
import {
	getDefaultOrganization,
	validateOrgFilter,
	getDefaultFilters
} from './helpers';
import { useLocation } from 'react-router-dom';
import authHelper from 'helpers/authHelper';
import localStorageHelper from 'helpers/localStorageHelper';
import { useQueryParams } from 'sharedHooks/useQuery';
import { translate } from 'helpers/translateHelper';
import { notify } from 'sharedComponents/GeneralNotification';
import { NOTIFICATION_TYPES } from 'sharedComponents/GeneralNotification/constants';


const useLoadDefaultFilters = ({ model, actions }) => {

	const location = useLocation();
	const history = useHistory();
	const { assetId, orgId } = useQueryParams();
	const { selectedFilters: savedFilters, organizations, loadingData, isCIAMSyncFlag, isAdmin } = model;

	const redirectToLogin = () => {
		authHelper.redirectToLogin(location.pathname + location.search);
	};

	const clearQueryParameter = () => {
		history.push({
			pathname: history.location.pathname,
		});
	};

	useEffect(() => {
		actions.getUserOrganizations();
		actions.getLastSelectedOrganization();
	}, []);

	useEffect(() => {
		if (loadingData.organizationsLoadingStatus === apiCallStatus.SUCCESS && !organizations.length) {
			redirectToLogin();
		}
	}, [loadingData.organizationsLoadingStatus, organizations]);

	useEffectOnlyOnce(() => {
		const { organizations: selectedOrganizations } = savedFilters;

		if (assetId) {
			actions.searchAssetRequest(assetId, [], null, clearQueryParameter, selectedOrganizations, history); // PASSING HISTORY FOR NAVIGATION FROM LEGACY ID TO MICRO-SERVICE ID ON ASSET SEARCH FROM GENERAL FILTER
		} else if (orgId) {
			actions.searchOrgRequest(orgId, organizations, isAdmin, isCIAMSyncFlag);
		} else {
			actions.getSitesAndAssetGroups(selectedOrganizations);
			let refreshFlag = true;
			if (isAdmin && !isCIAMSyncFlag) {
				refreshFlag = false;
			}
			actions.getAvailableAssets(selectedOrganizations, refreshFlag, model?.selectedFilters?.countries);
			if (isAdmin) {
				actions.setCIAMSyncFlag(false);
			}
		}
	}, [loadingData.organizationsLoadingStatus, savedFilters.organizations],
		([orgLoadingStatus, selectedOrganizations]) => {
			return orgLoadingStatus === apiCallStatus.SUCCESS && (selectedOrganizations?.length || orgId);
		});


	useEffect(() => {
		if (loadingData.organizationsLoadingStatus === apiCallStatus.SUCCESS &&
			(!savedFilters.organizations || savedFilters.organizations.length === 0)) {

			const lastSelectedOrg = model.lastSelectedOrganization;

			if (!lastSelectedOrg?.loadingStatus || lastSelectedOrg?.loadingStatus === apiCallStatus.LOADING) {
				return;
			}

			if (lastSelectedOrg?.loadingStatus === apiCallStatus.SUCCESS && lastSelectedOrg?.data) {
				const normalizedOrgData = {
					...lastSelectedOrg?.data,
					organizationID: lastSelectedOrg?.data?.organizationId || lastSelectedOrg?.data?.organizationID
				};
				const isLastSelectedOrgSelectionValid = validateOrgFilter(organizations, [normalizedOrgData]);
				if (isLastSelectedOrgSelectionValid) {
					const preselectedOrganizations = [normalizedOrgData];
					actions.setSelectedFilters({
						...getDefaultFilters(),
						organizations: preselectedOrganizations,
					});
					return;
				}
			}
			// fallback to local storage
			const selectedFiltersFromLS = localStorageHelper.getItemForUser('generalFilter.selectedFilters');

			const isOrgSelectionValid = validateOrgFilter(organizations, selectedFiltersFromLS?.organizations);

			const preselectedOrganizations =
				selectedFiltersFromLS?.organizations?.length && isOrgSelectionValid ?
					selectedFiltersFromLS.organizations :
					getDefaultOrganization(organizations);

			const preselectedFilters = selectedFiltersFromLS && isOrgSelectionValid ?
				selectedFiltersFromLS || savedFilters : getDefaultFilters();

			!isOrgSelectionValid && notify(translate('ABB.Powertrain.Frontend.generalFiltersResetFiltersNotifications'), NOTIFICATION_TYPES.INFO, true);
			if (preselectedOrganizations.length) {
				actions.setSelectedFilters({
					...preselectedFilters,
					organizations: preselectedOrganizations,

				});
			}
		}
	}, [organizations, savedFilters.organizations, model?.lastSelectedOrganization]);

};
export default useLoadDefaultFilters;
